import React, { useState } from 'react';
import { SERVER_ADDRESS } from "../env";
import i18n from "../i18n";
import { useMediaQuery } from "react-responsive";

import globe from "../assets/img/globe.png";

const lngs = {
  en: { nativeName: 'English' },
  it: { nativeName: 'Italiano' }
};

export default function Header() {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: "768px" });

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    console.log("Menu state toggled, now:", !isMenuOpen);
  };

  const closeMobileMenu = () => {
    console.log("Menu closed");
    setIsMenuOpen(false);
  };

  const [currentLanguage, setCurrentLanguage] = useState(i18n.resolvedLanguage);

  const handleChangeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setCurrentLanguage(lng);
  };

  return (
    <header id="header" className="row">
      {isMobile && (
        <button id="burger-menu" onClick={toggleMenu} aria-label="Toggle menu">
          {isMenuOpen ? `✖` : `☰`}
        </button>
      )}

      {isMobile ? (
        <div className={`menu ${isMenuOpen ? 'menu-open' : ''}`} onClick={closeMobileMenu}>
          <div className="header-nav">
            <a href={`${SERVER_ADDRESS}`} className="underline"><button>Home</button></a>
            <a href={`${SERVER_ADDRESS}preproduction`} className="underline"><button>Preproduction</button></a>
            <a href={`${SERVER_ADDRESS}production`} className="underline"><button>Production</button></a>
            <a href={`${SERVER_ADDRESS}postproduction`} className="underline"><button>Postproduction</button></a>
          </div>

          <div className="dropdown">
            <button className="dropbtn"><img src={globe} alt="Language" /></button>
            <div className="dropdown-content">
              {Object.keys(lngs).map((lng) => (
                <button
                  key={lng}
                  style={{ fontWeight: currentLanguage === lng ? 'bold' : 'normal' }}
                  type="button"
                  onClick={() => handleChangeLanguage(lng)}>
                  {lngs[lng].nativeName}
                </button>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div style={{ width: "100vw" }}>
          <div className="column column-80 column-offset-10 header-nav" style={{ padding: "0 0.5rem" }}>
            <a href={`${SERVER_ADDRESS}`} className="underline"><button>Home</button></a>
            <a href={`${SERVER_ADDRESS}preproduction`} className="underline"><button>Preproduction</button></a>
            <a href={`${SERVER_ADDRESS}production`} className="underline"><button>Production</button></a>
            <a href={`${SERVER_ADDRESS}postproduction`} className="underline"><button>Postproduction</button></a>
          </div>
          <div className="dropdown">
            <button className="dropbtn"><img src={globe} alt="Language" /></button>
            <div className="dropdown-content">
              {Object.keys(lngs).map((lng) => (
                <button
                  key={lng}
                  style={{ fontWeight: currentLanguage === lng ? 'bold' : 'normal' }}
                  type="button"
                  onClick={() => handleChangeLanguage(lng)}>
                  {lngs[lng].nativeName}
                </button>
              ))}
            </div>
          </div>

        </div>
      )}
    </header>
  );
}
